import { FieldProps } from 'formik'
import React from 'react'
import { Form } from 'react-bulma-components'
import FormField, { FormFieldProps } from './form-field'
import { get } from 'lodash'

export interface InputFieldProps extends FormFieldProps, FieldProps {
  type: string
}

const InputField: React.FunctionComponent<InputFieldProps> = props => {
  const { field, form, label, help, ...rest } = props
  if (props.field.value === undefined) props.field.value = ''
  return (
    <FormField label={label} help={help} error={get(form.errors, field.name) as string}>
      <Form.Input {...field} {...rest} />
    </FormField>
  )
}

export default InputField
